import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { usePathname } from "next/navigation";
import { DateTime } from "luxon";
import { printNumber } from "@src/utils/formatUtils";
import { createLabel } from "@src/utils/utils";
import { AppState } from "@app/store/store";
import { selectCompareCount } from "@entities/compare";

export const useMainFilterState = (previewQnt?: number | null) => {
    const [btnLabel, setBtnLabel] = useState("");
    const [isExpanded, setIsExpanded] = useState(false);
    const [locationState, setLocationState] = useState({
        isFilterShown: false,
        isConfirmShown: false
    });

    const filters = useSelector((state: AppState) => state.filters);
    const compareCount = useSelector(selectCompareCount);
    const pathname = usePathname();

    const targetPath = (pathname === "/" ? "/catalog" : pathname) || "/catalog";
    const showBadgeCount = compareCount > 0;

    useEffect(() => {
        const strVal = printNumber(previewQnt);
        if (strVal?.length > 0 && strVal !== "0") {
            setBtnLabel(
                `Показать ${strVal} ${createLabel(previewQnt || 0, [
                    "объявление",
                    "объявления",
                    "объявлений"
                ])}`
            );
        } else {
            setBtnLabel("Ничего не найдено");
        }
    }, [previewQnt]);

    useEffect(() => {
        const lastSavedTimestamp = localStorage.getItem("cityTimestamp");
        if (lastSavedTimestamp) {
            const lastSavedDateTime = DateTime.fromISO(lastSavedTimestamp);
            const now = DateTime.now();
            const daysSinceLastSave = now.diff(lastSavedDateTime, "days").days;

            setLocationState((prev) => ({
                ...prev,
                isConfirmShown: daysSinceLastSave <= -7
            }));
        }
    }, []);

    return {
        filters,
        compareCount,
        showBadgeCount,
        btnLabel,
        isExpanded,
        setIsExpanded,
        locationState,
        setLocationState,
        targetPath
    };
};